module.exports = "<app-message-page\n  title=\"500\"\n  description=\"Error de servidor\"\n></app-message-page>\n"